import { useT } from '../../i18n';
import type { Flight } from '../../lib/api';
import { creditsFr24 } from './flight';

/**
 * "Flight data: Flightradar24", under a time that came from it (its ToS 8.2; contract 1.4
 * `Flight.attribution`). Nothing for a flight that needs no credit. Shared by S3, S5 and S6.
 */
export function FlightDataCredit({
  flight,
  className = 'credit',
}: {
  flight: Flight | null | undefined;
  className?: string;
}) {
  const t = useT();
  if (!creditsFr24(flight)) return null;
  return <span className={className}>{t('S3.credit.flightradar24')}</span>;
}
